import { message } from 'antd';
import { publicKey } from '../action';
import { JSEncrypt } from 'jsencrypt';

export default async (params, str) => {
    const res = await publicKey(params);
    if(res.data.status === 0){
        const { public_key } = res.data.data || {};
        const encryptor = new JSEncrypt();
        encryptor.setPublicKey(public_key);
        return encryptor.encrypt(str);
    } else {
        message.error(res.data.msg);
        return '';
    }
}